import Styles from './FeatureGrid.module.css'

import type {Cta, ThemedVisual} from '../../../Index.types'
import {ColorDivider} from '../ColorDivider/ColorDivider'
import {FeatureGridVisual} from './FeatureGridVisual/FeatureGridVisual'

export interface FeatureGridProps {
  title: string
  hasColorDivider?: boolean
  layout: 'two-column' | 'two-then-three'
  items: Array<{
    title: string
    description: string
    icon?: 'mark-github'
    visual: ThemedVisual
    cta1: Cta
    cta2?: Cta
  }>
}

export type FeatureGridPropsData = Omit<FeatureGridProps, 'hasColorDivider' | 'layout'>

export const defaultProps: Partial<FeatureGridProps> = {}

export const FeatureGrid = (props: FeatureGridProps) => {
  const initializedProps: FeatureGridProps = {...defaultProps, ...props}
  const {items, hasColorDivider} = initializedProps

  return (
    <div className={Styles['FeatureGrid']}>
      {items.map((item, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <FeatureGridVisual key={`feature-grid-item-${index}`} {...item} />
      ))}

      {hasColorDivider && <ColorDivider variant="2" />}
    </div>
  )
}
